<h4>{{'labelcontainer.dialog.confirm' | translate}}</h4>
<div mat-dialog-content>
  
</div>
<div mat-dialog-actions>
  <button mat-button [mat-dialog-close]="data" cdkFocusInitial>{{'model.confirm.ok' | translate}}</button>
  <button mat-button (click)="onNoClick()">{{'model.confirm.cancel' | translate}}</button>
</div>